import { render, staticRenderFns } from "./MsgAfterLogin.vue?vue&type=template&id=82785e66&scoped=true&"
import script from "./MsgAfterLogin.vue?vue&type=script&lang=js&"
export * from "./MsgAfterLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82785e66",
  null
  
)

export default component.exports